/**
 * The group's US legal entities, to pick one by name (a rejected transaction is reported for the entity
 * that rejected it). Presentational: the caller loads the list and passes what it has - nothing yet
 * (loading), a failure, an empty list or the entities.
 */
import type { UsEntity } from '../../services/ofacBlocking.service';
import { colors } from '../../styles/theme';

const INPUT_STYLE = { border: `1px solid ${colors.border}` };

export default function UsEntitySelect({
  id,
  entities,
  error,
  value,
  onChange,
  onRetry,
}: Readonly<{
  id: string;
  /** null while the list is loading. */
  entities: UsEntity[] | null;
  error: string | null;
  value: string;
  onChange: (legalEntityId: string) => void;
  onRetry: () => void;
}>): JSX.Element {
  if (error !== null) {
    return (
      <div role="alert">
        <p className="text-xs" style={{ color: colors.danger }}>{error}</p>
        <button type="button" onClick={onRetry} className="mt-1 text-xs underline" style={{ color: colors.inkSoft }}>
          Try again
        </button>
      </div>
    );
  }
  if (entities === null) {
    return <output id={id} className="block text-xs" style={{ color: colors.muted }}>Loading…</output>;
  }
  if (entities.length === 0) {
    return (
      <p id={id} className="text-xs" style={{ color: colors.muted }}>
        No US legal entity is registered yet, so there is nothing to report a rejected transaction for.
      </p>
    );
  }
  return (
    <select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full px-3 py-2 rounded-lg text-sm"
      style={INPUT_STYLE}
    >
      <option value="">Choose the legal entity</option>
      {entities.map((entity) => (
        <option key={entity.legal_entity_id} value={entity.legal_entity_id} translate="no">
          {entity.name}
        </option>
      ))}
    </select>
  );
}
